angular.module('controllers').controller('carController', ['$scope', '$rootScope', '$controller', '$http', 'Crud', '$mdDialog', '$route', '$routeParams', '$location',
	function ($scope, $rootScope, $controller, $http, Crud, $mdDialog, $route, $routeParams, $location) {
		$rootScope.path = '/car';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'car';
		$scope.pathTemplate = 'distribution/cars';
		$scope.title = 'Masini';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'car_no';
		$scope.defaultItem = 10;
        $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Detalii', 'filter':0, 'filterType':'input'},
			'car_image':{'label':'Imagine', 'filter':0},
			'car_no':{'label':'Numar', 'filter':1, 'filterType':'input'},
			'car_mark':{'label':'Marca', 'filter':1, 'filterType':'input'},
			'car_series':{'label':'Serie', 'filter':1, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'car_no';
		$scope.additionals['publicPath'] = '/images/cars';

		$scope.additionals['function']= function(ev, data) {
			angular.element(document.querySelector('#fileImage')).val('');
		}

		$scope.additionals['functionResult']= function(ev, data) {
			if($scope.action == 'update' || $scope.action == 'store') {
				if (!angular.isUndefined(data.modelImage)) {
					$scope.modelData['car_image'] = data.modelImage;
					$scope.modelData['image'] = data.modelImage;
				}
			}
			if($scope.action == 'updatemultiple') {
				if (!angular.isUndefined($scope.modelsData)) {
					angular.forEach($scope.modelsData, function (item, key) {
						if (item.selected !== false) {
							$scope.modelsData[key]['car_image'] = data.modelImage[item['id']];
							$scope.modelsData[key]['image'] = data.modelImage[item['id']];
						}
					});
				}
			}
		}

		/* delete existing image */
		$scope.additionals['deleteImage'] = function (ev, model) {
			model['route'] = 'deleteImage';
			Crud.post('form-urlencoded', model, $scope.path + '/deleteImage')
				.success(function () {
					$scope.modelData['car_image'] = '';
					$scope.modelData['image'] = '';
					angular.element(document.querySelector('#image')).attr("src", '');
					$scope.image = '';

					model['multipleImages'] = '';
					model['car_image'] = '';
					model['image'] = '';
					var currentElement = angular.element(ev.currentTarget);
					angular.element(document.querySelector('#crop' + currentElement[0]['id'] + ' #img')).css('display', 'none');
				}).error(function (data) {
				$scope.errors = data.errors;

			});
		}

		/* update thumbs */
		$scope.updateThumbs = function (ev, path, modelId) {
			$scope.additionals['invalid'] = '';
			$scope.modelData = {};
			$mdDialog.show({
				controller: DialogController,
				templateUrl: 'updateThumbsDialog.tmpl.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {pathTemplate: $scope.pathTemplate, path: $scope.path, modelId: modelId, additionals: $scope.additionals}
			}).then();

			DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'path', 'modelId', 'additionals'];
			function DialogController($scope, $mdDialog, pathTemplate, path, modelId, additionals) {
				$scope.pathTemplate = pathTemplate;
				$scope.cancel = function () {
					$mdDialog.cancel();
				};
				$scope.additionals = additionals;
				$scope.path = path;

				$scope.additionals['buttonDisabled'] = true;
				$scope.isLoading = true;
				var post = {};
				post['car_id'] = modelId;
				post['route'] = 'updateThumbs';
				Crud.post('form-urlencoded', post, $scope.path + '/updateThumbs')
					.success(function (data) {
						if (!angular.isUndefined(data.invalid)) {
							$scope.additionals['invalid'] = data.invalid;
						} else {
							if (!angular.isUndefined($scope.additionals['functionResult'])) {
								$scope.additionals['functionResult'](ev, data);
							}
						}
						$scope.isLoading = false;
						$scope.additionals['buttonDisabled'] = false;
					})
					.error(function (data) {
						$scope.errors = data.errors;
						$scope.isLoading = false;
						$scope.additionals['buttonDisabled'] = false;

					});
			}
		};

		/* detail model */
		$rootScope.detailCar = function () {
			$scope.mode_action = 'dialog';

			Crud.show($routeParams.id, $scope.path)
				.success(function (data) {
					$scope.modelData = data;
				});
		}

	}]
)
